import { render, staticRenderFns } from "./ClickOnlyDoyangCard.vue?vue&type=template&id=40a6d1cf&scoped=true"
import script from "./ClickOnlyDoyangCard.vue?vue&type=script&lang=js"
export * from "./ClickOnlyDoyangCard.vue?vue&type=script&lang=js"
import style0 from "./ClickOnlyDoyangCard.vue?vue&type=style&index=0&id=40a6d1cf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40a6d1cf",
  null
  
)

export default component.exports